import type { ExportModel } from '@/models/Export/Model'
import ExportsApi from '@/models/Export/Api'
import DetailsState from '@/helpers/models/DetailsState'
import ListState from '@/helpers/models/ListState'
import type { LaravelPaginationResponse } from '@/interfaces/models/Laravel'

export class ExportDetailsState extends DetailsState<ExportsApi, ExportModel> {
	api = new ExportsApi()
}

export function useExportDetailsState() {
	return new ExportDetailsState()
}

export class ExportListState extends ListState<
	ExportsApi,
	ExportModel,
	LaravelPaginationResponse<ExportModel>
> {
	api = new ExportsApi()
}

export function useExportListState() {
	return new ExportListState()
}
